import { render, staticRenderFns } from "./Playground.vue?vue&type=template&id=b6afebd2&scoped=true&"
import script from "./Playground.vue?vue&type=script&lang=js&"
export * from "./Playground.vue?vue&type=script&lang=js&"
import style0 from "./Playground.vue?vue&type=style&index=0&id=b6afebd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6afebd2",
  null
  
)

export default component.exports